'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _reactRedux = require('react-redux');

var _search = require('redux/modules/search');

var _audiences = require('redux/modules/audiences');

var _organizations = require('redux/modules/organizations');

var _regions = require('redux/modules/regions');

var _tags = require('redux/modules/tags');

var _types = require('redux/modules/types');

var _venues = require('redux/modules/venues');

var _reduxRouter = require('redux-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBarContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    location: state.router.location,
    items: state.search.items
  };
}, function (dispatch) {
  return {
    dispatchAddAudience: function dispatchAddAudience(audience) {
      return dispatch((0, _audiences.add)(audience));
    },
    dispatchAddRegion: function dispatchAddRegion(audience) {
      return dispatch((0, _regions.add)(audience));
    },
    dispatchAddTag: function dispatchAddTag(tag) {
      return dispatch((0, _tags.add)(tag));
    },
    dispatchAddType: function dispatchAddType(type) {
      return dispatch((0, _types.add)(type));
    },
    dispatchAddOrganization: function dispatchAddOrganization(org) {
      return dispatch((0, _organizations.add)(org));
    },
    dispatchAddVenue: function dispatchAddVenue(venue) {
      return dispatch((0, _venues.add)(venue));
    },
    dispatchAutocomplete: function dispatchAutocomplete(query, searchIn, extra) {
      return dispatch((0, _search.autocomplete)(query, searchIn, extra));
    },
    dispatchClearSearch: function dispatchClearSearch() {
      return dispatch((0, _search.clear)());
    },
    dispatchPush: function dispatchPush(obj) {
      return dispatch((0, _reduxRouter.push)(obj));
    }
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchBarContainer, _Component);

  function SearchBarContainer(props) {
    (0, _classCallCheck3.default)(this, SearchBarContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBarContainer.__proto__ || (0, _getPrototypeOf2.default)(SearchBarContainer)).call(this, props));

    _this.onChange = function (event, _ref) {
      var newValue = _ref.newValue;

      _this.setState({
        value: newValue
      });
    };

    _this.onSubmit = function (event) {
      var dispatchPush = _this.props.dispatchPush; // eslint-disable-line no-shadow

      event.preventDefault();
      dispatchPush({ pathname: '/evenements', query: { q: _this.state.value } });
    };

    _this.onSuggestionsFetchRequested = function (_ref2) {
      var value = _ref2.value;

      var query = value.trim();

      var dispatchAutocomplete = _this.props.dispatchAutocomplete; // eslint-disable-line no-shadow

      if (_this.state.timeout) {
        clearTimeout(_this.state.timeout);
      }

      if (query.length >= 1) {
        _this.setState({
          timeout: setTimeout(function () {
            dispatchAutocomplete(query);
          }, 250)
        });
      }
    };

    _this.onSuggestionsClearRequested = function () {
      _this.props.dispatchClearSearch();
    };

    _this.onSuggestionSelected = function (event, _ref3) {
      var suggestion = _ref3.suggestion;

      event.preventDefault();
      var _this$props = _this.props,
          dispatchAddAudience = _this$props.dispatchAddAudience,
          dispatchAddOrganization = _this$props.dispatchAddOrganization,
          dispatchAddTag = _this$props.dispatchAddTag,
          dispatchAddType = _this$props.dispatchAddType,
          dispatchAddVenue = _this$props.dispatchAddVenue,
          dispatchPush = _this$props.dispatchPush; // eslint-disable-line no-shadow

      var query = {};
      query[suggestion.group] = suggestion.id;

      switch (suggestion.group) {
        case 'audiences':
          suggestion.tag = 'Public';
          dispatchAddAudience(suggestion);
          break;
        case 'organizations':
          suggestion.tag = 'Présenté par';
          dispatchAddOrganization(suggestion);
          break;
        case 'tags':
          suggestion.tag = 'Mot-clé';
          dispatchAddTag(suggestion);
          break;
        case 'types':
          suggestion.tag = 'Type';
          dispatchAddType(suggestion);
          break;
        case 'venues':
          suggestion.tag = 'Lieu';
          dispatchAddVenue(suggestion);
          break;
        case 'events':
          dispatchPush({ pathname: '/evenements/' + suggestion.slug + '/' + suggestion.id });
          break;
        default:
          break;
      }

      if (suggestion.group !== 'events') {
        dispatchPush({ pathname: '/evenements', query: query });
      }

      _this.setState({
        value: ''
      });
    };

    _this.renderSectionTitle = function (section) {
      var polyglot = _this.context.polyglot;

      return polyglot.t('event.entities.' + section.title);
    };

    _this.renderSuggestion = function (suggestion) {
      var polyglot = _this.context.polyglot;


      return _react2.default.createElement(
        'div',
        { 'data-group': polyglot.t('event.entities.' + suggestion.group) },
        suggestion.image && _react2.default.createElement('img', { src: suggestion.image, alt: suggestion.label }),
        _react2.default.createElement(
          'span',
          null,
          suggestion.label
        ),
        suggestion.venue && _react2.default.createElement(
          'div',
          { className: 'venue' },
          suggestion.venue
        )
      );
    };

    _this.state = {
      value: props.location.query.q || ''
    };
    return _this;
  }

  (0, _createClass3.default)(SearchBarContainer, [{
    key: 'render',
    value: function render() {
      var properties = {
        onClear: this.onSuggestionsClearRequested,
        onFetch: this.onSuggestionsFetchRequested,
        onSelect: this.onSuggestionSelected,
        onSubmit: this.onSubmit,
        onChange: this.onChange,
        query: this.state.value,
        renderSectionTitle: this.renderSectionTitle,
        renderSuggestion: this.renderSuggestion,
        suggestions: this.props.items
      };

      return _react2.default.createElement(_caligramReact.SearchBar, properties);
    }
  }]);
  return SearchBarContainer;
}(_react.Component), _class2.propTypes = {
  dispatchAddAudience: _react.PropTypes.func.isRequired,
  dispatchAddOrganization: _react.PropTypes.func.isRequired,
  dispatchAddTag: _react.PropTypes.func.isRequired,
  dispatchAddType: _react.PropTypes.func.isRequired,
  dispatchAddVenue: _react.PropTypes.func.isRequired,
  dispatchAutocomplete: _react.PropTypes.func.isRequired,
  dispatchClearSearch: _react.PropTypes.func.isRequired,
  dispatchPush: _react.PropTypes.func.isRequired,
  items: _react.PropTypes.array,
  location: _react.PropTypes.object
}, _class2.contextTypes = {
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  polyglot: _react.PropTypes.object
}, _temp)) || _class);
exports.default = SearchBarContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SearchBarContainer.js
// module id = 1187
// module chunks = 0